import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { Tabs } from '@ygtechnologies/rubus-ui';
import React, { ReactNode } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import { getProjectDetails } from '@/services/projects';
import { BygrProjectDetails } from '@/types';
import { useAsyncState } from '@/utils/hooks';
import ProjectDashboard from './ProjectDashboard';
// import ProjectInvitations from './ProjectInvitations';
import ProjectMembers from './ProjectMembers';
import ProjectModules from './ProjectModules';
import ProjectUnits from './ProjectUnits';
import ProjectLandingPage from './ProjectLandingPage';
import ProjectLinkedProject from './ProjectLinkedProject';
import theme from './Projects.module.scss';
import ProjectLicenses from './Licenses/ProjectLicenses';
import { ProjectFeatures } from './ProjectFeatures';
import ProjectTools from './ProjectTools';

export type ProjectDetailsTab =
    | 'dashboard'
    | 'members'
    | 'units'
    | 'modules'
    | 'invitations'
    | 'licenses'
    | 'landing-page'
    | 'linked-project'
    | 'features'
    | 'tools';
interface ProjectDetailsProps {
    tab: ProjectDetailsTab;
}
interface TabSettings {
    id: ProjectDetailsTab;
    name: string;
    render(opts: { project: BygrProjectDetails; reload(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: ({ project }) => <ProjectDashboard project={project} />,
    },
    {
        id: 'units',
        name: 'Units',
        render: ({ project }) => <ProjectUnits project={project} />,
    },
    {
        id: 'members',
        name: 'Members',
        render: ({ project }) => <ProjectMembers project={project} />,
    },
    {
        id: 'modules',
        name: 'Modules',
        render: ({ project, reload }) => <ProjectModules project={project} reloadProject={reload} />,
    },
    // {
    //     id: 'invitations',
    //     name: 'Invitations',
    //     render: ({ project, reload }) => <ProjectInvitations project={project} />,
    // },

    {
        id: 'licenses',
        name: 'Licenses',
        render: ({ project }) => <ProjectLicenses project={project} />,
    },
    {
        id: 'landing-page',
        name: 'Landing page',
        render: ({ project }) => <ProjectLandingPage project={project} />,
    },
    {
        id: 'linked-project',
        name: 'Linked project',
        render: ({ project, reload }) => <ProjectLinkedProject project={project} reloadProject={reload} />,
    },
    {
        id: 'features',
        name: 'Features',
        render: ({ project, reload }) => <ProjectFeatures project={project} reloadProject={reload} />,
    },
    {
        id: 'tools',
        name: 'Tools',
        render: ({ project }) => <ProjectTools project={project} />,
    },
];

const ProjectDetails: React.FC<ProjectDetailsProps> = () => {
    const { projectId, tab } = useParams<{ projectId: string; tab: ProjectDetailsTab }>();
    const [project, , reload] = useAsyncState(() => getProjectDetails(+projectId), [projectId], null);

    if (!project) {
        return <LoadingIndicator />;
    }

    const renderProjectType = () => {
        if (project.isParentProject) {
            return <span className={theme.projectType}>(Parent)</span>;
        } else if (project.parentProjectId) {
            return <span className={theme.projectType}>(Sub)</span>;
        } else {
            return null;
        }
    };

    const activeTab = tabs.find((x) => x.id === tab);

    return (
        <div>
            <h2>
                Project {project.name}
                {renderProjectType()}
            </h2>
            <Tabs.Container activeId={tab} variant="underline">
                {tabs.map((t) => (
                    <Tabs.Tab key={t.id} id={t.id} as={Link} to={`/projects/${project.id}/${t.id}`} label={t.name} />
                ))}
                <Tabs.Content>
                    <div className="tab-panel">{activeTab?.render({ project: project, reload: reload })}</div>
                </Tabs.Content>
            </Tabs.Container>
        </div>
    );
};

export default ProjectDetails;
